import { useForm } from '@mantine/form';
import { useState } from 'react';
import { validateText } from '../../../util/validation/commonValidation';
import type { BulkUpsertProductDto } from '../types/ProductDto';

const defaultBulkUpsertProductDto: BulkUpsertProductDto = {
	allSelected: false,
	keys: [],
	groupId: '',
	departmentId: '',
	supplierId: '',
	vatRateId: '',
};

export function useBulkUpsertProductForm() {
	const [inputs, setInputs] = useState<BulkUpsertProductDto>(
		defaultBulkUpsertProductDto,
	);

	const form = useForm<BulkUpsertProductDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			groupId: (value) => validateText(value, true, 'Group', 15),
			departmentId: (value) => validateText(value, true, 'Department', 15),
			supplierId: (value) => validateText(value, true, 'Supplier', 15),
			vatRateId: (value) => validateText(value, true, 'VAT Rate', 10),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
